import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Answer, Question, QuestionType, Section } from '../../model/contest/ContestTask';
import { MatSelectionList, MatSelectionListChange } from '@angular/material/list';

@Component({
  selector: 'contest-question',
  templateUrl: './contest-question.component.html',
  styleUrls: ['./contest-question.component.scss']
})
export class ContestQuestionComponent {

  @Input() question!: Question;
  @Input() section?: Section;
  @Input() editMode = false;
  @Input() localizeMode = false;
  @Input() disabled = false;

  @Input() examMode = false;
  @Input() backEnabled = false;
  @Input() forwardEnabled = false;

  @Output() edit = new EventEmitter<Question>();
  @Output() delete = new EventEmitter<Question>();
  @Output() answered = new EventEmitter<Answer[]>();

  @Output() back = new EventEmitter<void>();
  @Output() forward = new EventEmitter<void>();

  @ViewChild('multiAnswerList', {static: false}) protected multiAnswerList?: MatSelectionList;

  public refreshAnswers(): void {
    const selected = this.question.answers
      .filter(answer => answer.correct)
      .map(answer => answer.id);

    if (this.multiAnswerList) {
      this.multiAnswerList.deselectAll();

      this.multiAnswerList.options.forEach(option => {
        option.selected = selected.includes((option.value as Answer).id);
      });
    }
  }

  compareAnswers(a1: Answer, a2: Answer) {
    return a1 && a2 && a1.id === a2.id;
  }

  displayType(type: QuestionType): string {
    let value: string = '';

    switch (type) {
      case QuestionType.single_choice:
        value = $localize`:General|Contest question type single_choice answers count title@@general-contest-question-type-single_choice-answers-count-title:select one`;
        break;
      case QuestionType.multiple_choice:
        value = $localize`:General|Contest question type multiple_choice answers count title@@general-contest-question-type-multiple_choice-answers-count-title:multiple can be selected`;
        break;
    }

    return value;
  }

  setMultipleAnswerCorrect(selectionChange: MatSelectionListChange, list: MatSelectionList) {
    let selectedAnswers = list.selectedOptions.selected
      .map(option => option.value as Answer);

    if (this.question.type == QuestionType.single_choice) {
      list.deselectAll();
      selectionChange.options[0].selected = true;
      selectedAnswers = [selectionChange.options[0].value as Answer];
    }

    this.question.answers.forEach(answer => answer.correct = false);
    selectedAnswers.forEach(answer => answer.correct = true);

    this.question.answerInProgress = true;
    this.answered.emit(selectedAnswers);
  }

}
